import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react'
import { toast } from '@crosscode/gravity-components'
import { FtpClientModal } from './FtpClientModal'
import type { FtpOpenOptions } from './types'

export type { FtpOpenOptions, FtpConnectionType } from './types'

interface FtpContextValue {
  openFtp: (opts: FtpOpenOptions) => void
  closeFtp: () => void
}

const FtpContext = createContext<FtpContextValue | null>(null)

export function useFtpClient() {
  const ctx = useContext(FtpContext)
  if (!ctx) throw new Error('useFtpClient must be used within FtpClientHost')
  return ctx
}

export function FtpClientHost({ children }: { children?: ReactNode }) {
  const [open, setOpen] = useState(false)
  const [opts, setOpts] = useState<FtpOpenOptions | null>(null)

  const openFtp = useCallback((options: FtpOpenOptions) => {
    if (!options.host) {
      toast.error('Не указан IP-адрес устройства')
      return
    }
    setOpts(options)
    setOpen(true)
  }, [])

  const closeFtp = useCallback(() => {
    setOpen(false)
    setOpts(null)
  }, [])

  const value = useMemo(() => ({ openFtp, closeFtp }), [openFtp, closeFtp])

  return (
    <FtpContext.Provider value={value}>
      {children}
      <FtpClientModal open={open} options={opts} onClose={closeFtp} />
    </FtpContext.Provider>
  )
}
